export var ProductTypes;
(function (ProductTypes) {
    ProductTypes["Bundle"] = "Shop::Bundle";
    ProductTypes["Consultation"] = "Shop::Consultation";
    ProductTypes["HealthPlan"] = "Shop::HealthPlan";
    ProductTypes["Membership"] = "Shop::Membership";
    ProductTypes["Subscription"] = "Shop::Subscription";
    ProductTypes["Supplement"] = "Shop::Supplement";
    ProductTypes["Test"] = "Shop::Test";
    ProductTypes["Token"] = "Shop::Token";
})(ProductTypes || (ProductTypes = {}));
export var VariantTypes;
(function (VariantTypes) {
    VariantTypes["Bundle"] = "Shop::BundleVariant";
    VariantTypes["Consultation"] = "Shop::ConsultationVariant";
    VariantTypes["HealthPlan"] = "Shop::HealthPlanVariant";
    VariantTypes["Subscription"] = "Shop::SubscriptionVariant";
    VariantTypes["Supplement"] = "Shop::SupplementVariant";
    VariantTypes["Test"] = "Shop::TestVariant";
    VariantTypes["Membership"] = "Shop::MembershipVariant";
    VariantTypes["Token"] = "Shop::TokenVariant";
})(VariantTypes || (VariantTypes = {}));
export var ProductCategoryReferences;
(function (ProductCategoryReferences) {
    ProductCategoryReferences["Bundles"] = "SCWNM5306";
    ProductCategoryReferences["Consultations"] = "SCYSVTBIR";
    ProductCategoryReferences["HealthPlans"] = "SCCTKNHJF";
    ProductCategoryReferences["Memberships"] = "SCA4T78E1";
    ProductCategoryReferences["Supplements"] = "SC7D5LYKR";
    ProductCategoryReferences["Tests"] = "SCWY8Z9E3";
    ProductCategoryReferences["Tokens"] = "SCT378AE9";
})(ProductCategoryReferences || (ProductCategoryReferences = {}));
//# sourceMappingURL=constants.js.map